import { ComingSoonPage } from '@organisms/dataDisplay';
import { CalendarWeeklyViewPage } from './calendar';
import { RotationsListPage, ShiftsListPage } from './shiftsList';
import { ShiftsTemplatesListPage } from './templates';
import { ShiftsTypePresetsListPage } from './shiftPresetTypes';

const ViewTypes: Record<string, JSX.Element> = {
  calendarByAssignee: <CalendarWeeklyViewPage />,
  calendarByRole: <ComingSoonPage />,
  calendarMonthlyPlanning: <ComingSoonPage />,
  listAllShifts: <ShiftsListPage />,
  listSeriesNRotations: <RotationsListPage />,
  templatesShiftsSeriesRotations: <ShiftsTemplatesListPage />,
  templatesSeriesNRotations: <ShiftsTypePresetsListPage />,
  historyLog: <ComingSoonPage />,
} as const;

type Props = {
  viewType: keyof typeof ViewTypes;
};

export function Component({ viewType }: Props) {
  return ViewTypes[viewType];
}
